import { shell } from './shell.js';
import { common } from './common.js';
import { dashboard } from './dashboard.js';
import { sessions } from './sessions.js';
import { tickets } from './tickets.js';
import { signals } from './signals.js';
import { alerts } from './alerts.js';
import { projects } from './projects.js';
import { billing } from './billing.js';
import { members } from './members.js';
import { keys } from './keys.js';
import { security } from './security.js';
import { sso } from './sso.js';
import { live } from './live.js';
import { configuration } from './configuration.js';
import { ai } from './ai.js';
import { admin } from './admin.js';
import { analytics } from './analytics.js';
import { replay } from './replay.js';
import { integrations } from './integrations.js';
import { oauth } from './oauth.js';
import { insights } from './insights.js';
import { help } from './help.js';
import { recording } from './recording.js';
import { ask } from './ask.js';
import type { Lang } from '../lang.js';

/**
 * The whole dictionary, assembled per language.
 *
 * Each area module exports `{ en, tr }` with Turkish typed as `typeof en`, so
 * a missing translation is a compile error. Areas are separate files because
 * one file holding every string in the product becomes impossible to review.
 */
interface Dict {
  shell: typeof shell.en;
  common: typeof common.en;
  dashboard: typeof dashboard.en;
  sessions: typeof sessions.en;
  tickets: typeof tickets.en;
  signals: typeof signals.en;
  ask: typeof ask.en;
  alerts: typeof alerts.en;
  projects: typeof projects.en;
  billing: typeof billing.en;
  members: typeof members.en;
  keys: typeof keys.en;
  security: typeof security.en;
  sso: typeof sso.en;
  live: typeof live.en;
  configuration: typeof configuration.en;
  ai: typeof ai.en;
  admin: typeof admin.en;
  analytics: typeof analytics.en;
  replay: typeof replay.en;
  integrations: typeof integrations.en;
  oauth: typeof oauth.en;
  insights: typeof insights.en;
  help: typeof help.en;
  recording: typeof recording.en;
}

export const COPY: Record<Lang, Dict> = {
  en: { ask: ask.en, recording: recording.en, help: help.en, insights: insights.en, integrations: integrations.en, oauth: oauth.en, replay: replay.en, analytics: analytics.en, admin: admin.en, ai: ai.en, configuration: configuration.en, live: live.en, sso: sso.en, security: security.en, keys: keys.en, members: members.en, billing: billing.en, projects: projects.en, alerts: alerts.en, signals: signals.en, tickets: tickets.en, shell: shell.en, common: common.en, dashboard: dashboard.en, sessions: sessions.en },
  tr: { ask: ask.tr, recording: recording.tr, help: help.tr, insights: insights.tr, integrations: integrations.tr, oauth: oauth.tr, replay: replay.tr, analytics: analytics.tr, admin: admin.tr, ai: ai.tr, configuration: configuration.tr, live: live.tr, sso: sso.tr, security: security.tr, keys: keys.tr, members: members.tr, billing: billing.tr, projects: projects.tr, alerts: alerts.tr, signals: signals.tr, tickets: tickets.tr, shell: shell.tr, common: common.tr, dashboard: dashboard.tr, sessions: sessions.tr },
};

export type Copy = (typeof COPY)['en'];
